import React from 'react';

import './gridFooterCell.scss';

const GridFooterCell = (props) => {
  let sum = 0;
  props.gridData.map((row) => {
    let tempValue = row[props.field] ? row[props.field].replace(/,/g, '') : 0;
    sum += 1 * tempValue;
  });

  return (
    <td className="grid-footer-cell">
      {props.includeTotalCount ? (
        <div>
          {sum.toLocaleString()}
        </div>
      ) : null}
    </td>
  );
};

export default GridFooterCell;
